import { render, staticRenderFns } from "./BotPressChat.vue?vue&type=template&id=2489c02c&"
import script from "./BotPressChat.vue?vue&type=script&lang=js&"
export * from "./BotPressChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports